<template>
  <div class="map-wrapper">
    <div ref="mapViewNode" class="map-container"></div>
    
    <div class="legend-panel" v-if="rainStations.length > 0">
      <div class="legend-section">
        <h4>降雨警報</h4>
        <div class="legend-item">
          <svg viewBox="0 -5 32 30" width="18" height="18" class="legend-icon">
            <path d="M10 13a6 6 0 0 1-1-11.9 7 7 0 0 1 13.5-1.5 5 5 0 0 1 0.5 9.5h-13z M7 16l-2 4a1.5 1.5 0 0 0 3 0z M12 16l-2 4a1.5 1.5 0 0 0 3 0z M17 16l-2 4a1.5 1.5 0 0 0 3 0z M22 16l-2 4a1.5 1.5 0 0 0 3 0z" fill="#8e44ad" stroke="#fff" stroke-width="1"></path>
          </svg>
          超大豪雨
        </div>
        <div class="legend-item">
          <svg viewBox="0 -5 32 30" width="18" height="18" class="legend-icon">
            <path d="M10 13a6 6 0 0 1-1-11.9 7 7 0 0 1 13.5-1.5 5 5 0 0 1 0.5 9.5h-13z M7 16l-2 4a1.5 1.5 0 0 0 3 0z M12 16l-2 4a1.5 1.5 0 0 0 3 0z M17 16l-2 4a1.5 1.5 0 0 0 3 0z M22 16l-2 4a1.5 1.5 0 0 0 3 0z" fill="#e74c3c" stroke="#fff" stroke-width="1"></path>
          </svg>
          大豪雨
        </div>
        <div class="legend-item">
          <svg viewBox="0 -5 32 30" width="18" height="18" class="legend-icon">
            <path d="M10 13a6 6 0 0 1-1-11.9 7 7 0 0 1 13.5-1.5 5 5 0 0 1 0.5 9.5h-13z M7 16l-2 4a1.5 1.5 0 0 0 3 0z M12 16l-2 4a1.5 1.5 0 0 0 3 0z M17 16l-2 4a1.5 1.5 0 0 0 3 0z M22 16l-2 4a1.5 1.5 0 0 0 3 0z" fill="#e67e22" stroke="#fff" stroke-width="1"></path>
          </svg>
          豪雨
        </div>
        <div class="legend-item">
          <svg viewBox="0 -5 32 30" width="18" height="18" class="legend-icon">
            <path d="M10 13a6 6 0 0 1-1-11.9 7 7 0 0 1 13.5-1.5 5 5 0 0 1 0.5 9.5h-13z M7 16l-2 4a1.5 1.5 0 0 0 3 0z M12 16l-2 4a1.5 1.5 0 0 0 3 0z M17 16l-2 4a1.5 1.5 0 0 0 3 0z M22 16l-2 4a1.5 1.5 0 0 0 3 0z" fill="#f1c40f" stroke="#fff" stroke-width="1"></path>
          </svg>
          大雨
        </div>
        <!--
        <div class="legend-item">
          <svg viewBox="0 -5 32 30" width="18" height="18" class="legend-icon">
            <path d="M10 13a6 6 0 0 1-1-11.9 7 7 0 0 1 13.5-1.5 5 5 0 0 1 0.5 9.5h-13z M7 16l-2 4a1.5 1.5 0 0 0 3 0z M12 16l-2 4a1.5 1.5 0 0 0 3 0z M17 16l-2 4a1.5 1.5 0 0 0 3 0z M22 16l-2 4a1.5 1.5 0 0 0 3 0z" fill="#3498db" stroke="#fff" stroke-width="1"></path>
          </svg>
          正常 (測試顯示)
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import { loadModules } from 'esri-loader';

export default {
  name: 'MapComponents',
  props: {
    projectData: {
      type: Object,
      default: () => ({}),
    },
    rainData: {
      type: Object,
      default: () => ({}),
    },
    rainList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      stations: [],
      rainStations: [],
    };
  },
  watch: {
    projectData: {
      handler(newData) {
        if (newData && newData.area && newData.area.length > 0) {
          this.processProjectData(newData);
          this.triggerRender();
        }
      },
      immediate: true,
      deep: true,
    },
    rainData: {
      handler() {
        this.processRainData();
        this.triggerRender();
      },
      deep: true,
    },
    rainList: {
      handler() {
        this.processRainData();
        this.triggerRender();
      },
      deep: true,
    },
  },
  created() {
    this.view = null;
    this.graphicsLayer = null;
    this.GraphicClass = null;
  },
  mounted() {
    this.initializeMap();
    this.processRainData();
  },
  beforeDestroy() {
    if (this.view) {
      this.view.container = null;
      if (typeof this.view.destroy === 'function') {
        this.view.destroy();
      }
      this.view = null;
    }
  },
  methods: {
    triggerRender() {
      if (this.GraphicClass && this.graphicsLayer) {
        this.renderMapPoints();
      }
    },

    processProjectData(data) {
      const statusWeight = { WSL: 4, AL: 3, GREEN: 2, down: 1 };
      const weightToStatus = { 4: 'WSL', 3: 'AL', 2: 'GREEN', 1: 'down', 0: 'down' };
      const newStations = [];

      data.area.forEach((area) => {
        let maxWeight = 0;
        let sumLon = 0;
        let sumLat = 0;
        let coordCount = 0;

        const stations = area.station || [];
        stations.forEach((station) => {
          const instruments = station.instrument || [];
          instruments.forEach((instrument) => {
            const status = instrument.status || 'down';
            const weight = statusWeight[status] || 0;
            if (weight > maxWeight) maxWeight = weight;

            const coords = instrument.latestVersion?.coordinates;
            if (coords && Array.isArray(coords) && coords.length >= 2) {
              if (coords[0] !== null && coords[1] !== null) {
                sumLon += coords[0];
                sumLat += coords[1];
                coordCount++;
              }
            }
          });
        });

        if (coordCount > 0) {
          newStations.push({
            name: area.name,
            status: weightToStatus[maxWeight],
            lon: sumLon / coordCount,
            lat: sumLat / coordCount,
          });
        }
      });
      this.stations = newStations;
    },

    processRainData() {
      if (!this.rainList.length || !Object.keys(this.rainData).length) return;

      const rainDataArray = Object.values(this.rainData);

      this.rainStations = this.rainList.map((item) => {
        const rData = rainDataArray.find(r => r.name === item.name) || {};
        
        const hr_1 = rData['mm/1HR'] || 0;
        const hr_3 = rData['mm/3HR'] || 0;
        const hr_24 = rData['mm/24HR'] || 0;

        let calcStatus = item.status;

        if (hr_24 > 80 || hr_1 > 40) {
          if (hr_24 > 200 || hr_3 > 100) {
            if (hr_24 > 350 || hr_3 > 200) {
              if (hr_24 > 500) {
                calcStatus = 'EXTREME_TORRENTIAL_RAIN'; // 超大豪雨
              } else {
                calcStatus = 'SUPER_TORRENTIAL_RAIN';   // 大豪雨
              }
            } else {
              calcStatus = 'TORRENTIAL_RAIN';           // 豪雨
            }
          } else {
            calcStatus = 'HEAVY_RAIN';                  // 大雨
          }
        }

        return {
          name: item.name,
          status: calcStatus,
          lon: item.coordinates[0],
          lat: item.coordinates[1],
          hr_1,
          hr_3,
          hr_24,
        };
      }).filter(station => station.status !== 'GREEN' && station.status !== 'down');
    },

    async initializeMap() {
      try {
        const [Map, SceneView, Graphic, GraphicsLayer] = await loadModules([
          'esri/Map',
          'esri/views/SceneView',
          'esri/Graphic',
          'esri/layers/GraphicsLayer',
        ], { css: true });

        this.GraphicClass = Graphic;

        const map = new Map({
          basemap: 'topo-vector',
          ground: 'world-elevation',
        });

        this.view = new SceneView({
          container: this.$refs.mapViewNode,
          map,
          camera: {
            position: {
              longitude: 121.15976959004693,
              latitude: 22.43824403665329,
              z: 30771.865782329813,
            },
            heading: 353.19748283672465,
            tilt: 81.32469801831193,
          },
          ui: {
            components: ['zoom', 'attribution'],
          },
          popup: {
            dockOptions: {
              buttonEnabled: false,
            },
            actions: [],
          },
        });

        this.graphicsLayer = new GraphicsLayer();
        map.add(this.graphicsLayer);

        if (this.stations.length > 0 || this.rainStations.length > 0) {
          this.renderMapPoints();
        }

        this.view.on('click', (event) => {
          this.view.hitTest(event).then((response) => {
            if (response.results.length > 0) {
              const graphicResult = response.results.find(
                (result) => 
                  result.graphic && 
                  result.graphic.attributes && 
                  result.graphic.attributes.Type === 'IoT 設備',
              );

              console.log('Hit Test Results:', response.results);

              if (graphicResult) {
                const clickedGraphic = graphicResult.graphic;
                const lon = clickedGraphic.geometry.longitude;
                const lat = clickedGraphic.geometry.latitude;
                console.log(`Clicked on IoT Device: ${clickedGraphic.attributes.Name} at (${lon}, ${lat})`);

                const stationName = clickedGraphic.attributes.Name; 


                this.$confirm(`要跳轉到地圖頁面嗎? (測站：${stationName})`, '提示', {
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(() => {
                  this.toMap(lon, lat);
                }).catch(() => {
                  // 點擊取消，不做任何動作
                });
              }
            }
          });
        });
      } catch (error) {
        console.error('ArcGIS 地圖初始化失敗:', error);
      }
    },

    renderMapPoints() {
      this.graphicsLayer.removeAll();

      this.stations.forEach((station) => {
        const pointGraphic = new this.GraphicClass({
          geometry: { type: 'point', longitude: station.lon, latitude: station.lat },
          symbol: {
            type: 'simple-marker',
            style: 'circle',
            size: 12,
            color: station.status === 'GREEN' ? [46, 204, 113] 
              : station.status === 'AL' ? [241, 196, 15] 
                : station.status === 'WSL' ? [231, 76, 60] 
                  : [149, 165, 166],
            outline: { color: [0, 0, 0], width: 1 },
          },
          attributes: {
            Name: station.name,
            Type: 'IoT 設備',
            Status: station.status === 'GREEN' ? '正常' 
              : station.status === 'AL' ? '警戒值' 
                : station.status === 'WSL' ? '行動值' : '未更新',
          },
          popupTemplate: {
            title: '{Name}',
            content: '<div style="font-size: 14px;"><b>當前狀態:</b> {Status}</div>',
          },
        });
        this.graphicsLayer.add(pointGraphic);
      });

      const getCloudSvgUrl = (fillColor) => {
        const svgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -5 32 30" width="24" height="24"><path d="M10 13a6 6 0 0 1-1-11.9 7 7 0 0 1 13.5-1.5 5 5 0 0 1 0.5 9.5h-13z M7 16l-2 4a1.5 1.5 0 0 0 3 0z M12 16l-2 4a1.5 1.5 0 0 0 3 0z M17 16l-2 4a1.5 1.5 0 0 0 3 0z M22 16l-2 4a1.5 1.5 0 0 0 3 0z" fill="${fillColor}" stroke="#fff" stroke-width="1.5"/></svg>`;
        return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
      };

      this.rainStations.forEach((station) => {
        let colorHex = '#3498db';
        let statusName = '正常';

        switch (station.status) {
          case 'EXTREME_TORRENTIAL_RAIN':
            colorHex = '#8e44ad'; // Purple
            statusName = '超大豪雨';
            break;
          case 'SUPER_TORRENTIAL_RAIN':
            colorHex = '#e74c3c'; // Red
            statusName = '大豪雨';
            break;
          case 'TORRENTIAL_RAIN':
            colorHex = '#e67e22'; // Orange
            statusName = '豪雨';
            break;
          case 'HEAVY_RAIN':
            colorHex = '#f1c40f'; // Yellow
            statusName = '大雨';
            break;
        }

        const pointGraphic = new this.GraphicClass({
          geometry: { type: 'point', longitude: station.lon, latitude: station.lat },
          symbol: {
            type: 'picture-marker',
            url: getCloudSvgUrl(colorHex),
            width: '24px',
            height: '24px',
          },
          attributes: {
            Name: station.name,
            Status: statusName,
            hr1: station.hr_1,
            hr3: station.hr_3,
            hr24: station.hr_24,
          },
          popupTemplate: {
            title: '雨量站: {Name}',
            content: `
              <div style="font-size: 14px;">
                <b>降雨狀態:</b> {Status}<br>
                <b>1小時雨量:</b> {hr1} mm<br>
                <b>3小時雨量:</b> {hr3} mm<br>
                <b>24小時雨量:</b> {hr24} mm
              </div>
            `,
          },
        });
        this.graphicsLayer.add(pointGraphic);
      });
    },

    toMap(lon, lat) {
      this.$router.push({
        name: 'slope-map',
        params: { lat, lon },
      });
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.map-container {
  width: 100%;
  height: 400px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.legend-panel {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 10px 15px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 12px;
  pointer-events: none;
  z-index: 10;
}

.legend-section h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #333;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: #444;
  font-weight: 500;
}

.legend-icon {
  margin-right: 8px;
  filter: drop-shadow(0px 1px 2px rgba(0,0,0,0.2));
}
</style>